module.exports = __webpack_public_path__ + "img/image154.f87af617.jpg";